/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Brand = {
  __typename?: 'Brand';
  campaigns: CampaignsPaginated;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['String']['output'];
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rawStr?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type BrandCampaignsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignPitch?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hookStrength?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journalistSearchTerms?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  pitchHook?: Maybe<Scalars['String']['output']>;
  pitchTopic?: Maybe<Scalars['String']['output']>;
  rawStr?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CampaignsFilterInput = {
  brands?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CampaignsPaginated = {
  __typename?: 'CampaignsPaginated';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<Campaign>;
};

export type LoggedInUser = {
  __typename?: 'LoggedInUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  rawStr?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** An example field added by the generator */
  testField: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  brand: Brand;
  brands: Array<Brand>;
  campaigns: CampaignsPaginated;
  me: LoggedInUser;
  searchWebAndNews: WebAndNewsPaginated;
};


export type QueryBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<CampaignsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchWebAndNewsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WebAndNewsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type WebAndNews = {
  __typename?: 'WebAndNews';
  description: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WebAndNewsFilterInput = {
  limitDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Scalars['String']['input']>;
  mkt?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchOpt?: InputMaybe<WebAndNewsSearchOpt>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WebAndNewsPaginated = {
  __typename?: 'WebAndNewsPaginated';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<WebAndNews>;
};

export type WebAndNewsSearchOpt =
  /** Use AI based search results */
  | 'ai'
  /** Use traditional search engine with filtering */
  | 'classic';

export type LoadLoggedInUserForHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadLoggedInUserForHeaderQuery = { __typename?: 'Query', me: { __typename?: 'LoggedInUser', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, rawStr?: string | null } };

export type ListBrandsForBrandSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBrandsForBrandSelectorQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'Brand', id: string, title: string, website?: string | null }> };

export type ListCampaignsForSidebarQueryVariables = Exact<{
  brands: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListCampaignsForSidebarQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignsPaginated', items: Array<{ __typename?: 'Campaign', id: string, title: string, kind: string, description?: string | null, campaignPitch?: string | null, pitchHook?: string | null, hookStrength?: string | null, pitchTopic?: string | null, journalistSearchTerms?: string | null, rawStr?: string | null, createdAt: string, updatedAt: string }> } };

export type BrandInfoForSidebarQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type BrandInfoForSidebarQuery = { __typename?: 'Query', brand: { __typename?: 'Brand', id: string, title: string } };

export type ListCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCampaignsQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'Brand', id: string, title: string, rawStr?: string | null, campaigns: { __typename?: 'CampaignsPaginated', items: Array<{ __typename?: 'Campaign', id: string, title: string, description?: string | null, campaignPitch?: string | null, pitchHook?: string | null, hookStrength?: string | null, pitchTopic?: string | null, journalistSearchTerms?: string | null, rawStr?: string | null, createdAt: string, updatedAt: string }> } }> };

export type SearchWebAndNewsQueryVariables = Exact<{
  filter: WebAndNewsFilterInput;
}>;


export type SearchWebAndNewsQuery = { __typename?: 'Query', searchWebAndNews: { __typename?: 'WebAndNewsPaginated', items: Array<{ __typename?: 'WebAndNews', description: string, publishedAt?: string | null, thumbnail?: string | null, title: string, url: string }> } };


export const LoadLoggedInUserForHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadLoggedInUserForHeader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"rawStr"}}]}}]}}]} as unknown as DocumentNode<LoadLoggedInUserForHeaderQuery, LoadLoggedInUserForHeaderQueryVariables>;
export const ListBrandsForBrandSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListBrandsForBrandSelector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}}]} as unknown as DocumentNode<ListBrandsForBrandSelectorQuery, ListBrandsForBrandSelectorQueryVariables>;
export const ListCampaignsForSidebarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCampaignsForSidebar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brands"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brands"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brands"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"campaignPitch"}},{"kind":"Field","name":{"kind":"Name","value":"pitchHook"}},{"kind":"Field","name":{"kind":"Name","value":"hookStrength"}},{"kind":"Field","name":{"kind":"Name","value":"pitchTopic"}},{"kind":"Field","name":{"kind":"Name","value":"journalistSearchTerms"}},{"kind":"Field","name":{"kind":"Name","value":"rawStr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<ListCampaignsForSidebarQuery, ListCampaignsForSidebarQueryVariables>;
export const BrandInfoForSidebarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandInfoForSidebar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<BrandInfoForSidebarQuery, BrandInfoForSidebarQueryVariables>;
export const ListCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"rawStr"}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"campaignPitch"}},{"kind":"Field","name":{"kind":"Name","value":"pitchHook"}},{"kind":"Field","name":{"kind":"Name","value":"hookStrength"}},{"kind":"Field","name":{"kind":"Name","value":"pitchTopic"}},{"kind":"Field","name":{"kind":"Name","value":"journalistSearchTerms"}},{"kind":"Field","name":{"kind":"Name","value":"rawStr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCampaignsQuery, ListCampaignsQueryVariables>;
export const SearchWebAndNewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchWebAndNews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WebAndNewsFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchWebAndNews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SearchWebAndNewsQuery, SearchWebAndNewsQueryVariables>;